import { Box } from "@hightouch/htui";

/** The page's main landmark, which the skip link moves focus to. */
export const MAIN_CONTENT_ID = "main-content";

/** The first stop for the keyboard: it skips the sidebar to the page, and shows only while focused. */
export const SkipToContentLink = () => (
  <Box
    as="a"
    href={`#${MAIN_CONTENT_ID}`}
    position="fixed"
    top={2}
    left={2}
    zIndex="skipLink"
    px={3}
    py={2}
    borderRadius="lg"
    bg="white"
    boxShadow="md"
    fontWeight="medium"
    color="text.primary"
    transform="translateY(calc(-100% - var(--chakra-space-4)))"
    _focusVisible={{ transform: "none", outline: "none", boxShadow: "outline" }}
  >
    Skip to content
  </Box>
);
